<script setup lang="ts">
import LogoIconComponent from './LogoIconComponent.vue'
import {onMounted} from 'vue'

interface Emits {
  (e: 'imageLoad'): void
}
const emit = defineEmits<Emits>()

interface Props {
  alertText?: string
}
const props = withDefaults(defineProps<Props>(), {
  alertText: null,
})

onMounted(async () => {
  emit('imageLoad')
})
</script>

<template>
  <div class="initial-loading-screen">
    <!--    <div class="protip" v-if="props.alertText">{{props.alertText}}</div>-->
    <LogoIconComponent isLoading :size="64"/>
  </div>
</template>

<style scoped lang="scss">
@use '../../../styles/variables' as variables;

.initial-loading-screen {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 1000000;
  background: map-get(variables.$colors, surface);
}

.logo {
  font-size: map-get(variables.$textSizes, text-4xl);
}

.protip {
  position: fixed;
  bottom: 30px;
  background: rgb(255 255 255 / 10%);
  padding: map-get(variables.$spacing, space-1) map-get(variables.$spacing, space-4);
  border-radius: 30px;
}
</style>
